/**
 * Historia 125 (MIC-4261) — how the request form NAMES a part reference.
 *
 * Novaindef reads `code (name)`; every other installation keeps `name (code)`. The order comes from
 * `frontEndConfig.partReferenceDisplayFormat`, published by Sun as it is configured -- Sun does NOT
 * normalise it (its S3), so the consumer does (RN3): anything that is not a known format, including
 * a missing field or a typo, degrades to the default silently. A typo in a property must never
 * block somebody from creating an order (E2).
 *
 * This is the SINGLE authority for composing the label (03-dominio.md, `PartReferenceLabel`). The
 * form paints the selector with it, resolves the selection with it and stores the order with it: if
 * the three ever diverged, the user would pick an option the form cannot find (E4).
 */

export const NAME_CODE = 'NAME_CODE'
export const CODE_NAME = 'CODE_NAME'

const KNOWN_FORMATS = [NAME_CODE, CODE_NAME]

/**
 * The format to use, normalised. Case-insensitive because the value travels as a raw string from a
 * property file; unknown or absent falls back to the default.
 *
 * @param {string} [format] Raw value of `frontEndConfig.partReferenceDisplayFormat`
 * @returns {string} `NAME_CODE` or `CODE_NAME`
 */
export const normalizeDisplayFormat = (format) => {
  const candidate = typeof format === 'string' ? format.trim().toUpperCase() : ''
  return KNOWN_FORMATS.includes(candidate) ? candidate : NAME_CODE
}

/**
 * The label of a part reference in the request form.
 *
 * @param {Object} partReference Reference with `name` and `code`
 * @param {string} [format] Raw display format from `frontEndConfig` (normalised here)
 * @returns {string} `name (code)` or `code (name)`
 */
export const formatPartReference = (partReference, format) => {
  const name = partReference?.name ?? ''
  const code = partReference?.code ?? ''
  return normalizeDisplayFormat(format) === CODE_NAME
    ? code + ' (' + name + ')'
    : name + ' (' + code + ')'
}

export default formatPartReference
